module.exports = __webpack_public_path__ + "static/media/APOTHEO_LABO_MODILAC.829f6c5e.png";